import useTranslation from "next-translate/useTranslation";
import { useEffect, useState } from "react";
import { useSelector } from "react-redux";
import { selectors as ListingreducerSelectors } from "../../../../../../redux/slices/v2/ListingReducer";
import Dropdown from "../DropDown/DropDown";
import classes from "./BienTypeSelect.module.scss";
import CheckMark from "./CheckMark";

type PossibleTypes =
  | "Appartement"
  | "Villa"
  | "Maison"
  | "Riad"
  | "Bureau"
  | "Terrain"
  | "Commerce"
  | "Local Industriel"
  | "Villas"
  | "Appartements"
  | "Lots de terrains"
  | "Select_All";

const allTypes = [
  "Appartement",
  "Villa",
  "Maison",
  "Riad",
  "Bureau",
  "Terrain",
  "Commerce",
  "Local Industriel",
  "Select_All",
];
const BienTypesOptionsAchatLocation: {
  value: PossibleTypes;
}[] = [
    { value: "Appartement" },
    { value: "Villa" },
    { value: "Maison" },
    { value: "Riad" },
    { value: "Bureau" },
    { value: "Terrain" },
    { value: "Commerce" },
    { value: "Local Industriel" },
  ];
const BienTypesProjetsNeuf: { value: PossibleTypes }[] = [
  { value: "Appartements" },
  { value: "Villas" },
  { value: "Lots de terrains" },
];

type TypesList =
  | (
    | "Appartement"
    | "Villa"
    | "Maison"
    | "Bureau"
    | "Terrain"
    | "Commerce"
    | "Riad"
    | "Local Industriel"
  )[]
  | ("Villas" | "Appartements" | "Lots de terrains")[];

export default function BienTypeSelect({
  hideTitle = false,
  styleForFilters = false,
  transactionType,
  onTypesSelected,
  onTypesSelectionChange = () => { },
  variant = "SELECT",
  fromLp,
}: {
  hideTitle?: boolean;
  styleForFilters?: boolean;
  transactionType: "Vente" | "Location" | "Projets Neufs" | "";
  onTypesSelected: (types: any) => void;
  onTypesSelectionChange?: (types: any) => void;
  variant?: "SELECT" | "VIEW";
  fromLp?: boolean;
}) {
  const { t } = useTranslation("annonceAchat");

  const BienTypesOptions = {
    Vente: BienTypesOptionsAchatLocation,
    Location: BienTypesOptionsAchatLocation,
    "Projets Neufs": BienTypesOptionsAchatLocation,
  }[transactionType];

  const listingsSearchPayload = useSelector(
    ListingreducerSelectors.searchPayloadSelector
  );

  const [displayInputTypes, setDisplayInputTypes] = useState<boolean>(false);
  // const [allTypesSelected, setAllTypesSelected] = useState<boolean>(false);
  const [type, setType] = useState<PossibleTypes[] | string[]>(
    listingsSearchPayload?.type ?? []
  );
  const [dropdownToggle, setDropdownToggle] = useState(false);

  const [initialisedFromRedux, setinitialisedFromRedux] =
    useState<boolean>(false);

  const onTypeSelectChange = (e, value) => {
    if (e) {
      if (type.concat(value).length == BienTypesOptions.length) {
        setType(type.concat(value).concat("Select_All"));
        onTypesSelectionChange(type.concat(value).concat("Select_All"));
      } else {
        setType(type.concat(value));
        onTypesSelectionChange(type.concat(value));
      }
    } else {
      setType(
        type.filter((item) => {
          return item != value && item != "Select_All";
        })
      );
      onTypesSelectionChange(
        type.filter((item) => {
          return item != value && item != "Select_All";
        })
      );
    }
  };
  const handleChangeSelectAll = (e) => {
    if (e) {
      setType(allTypes);
      onTypesSelectionChange(allTypes);
    } else {
      setType([]);
      onTypesSelectionChange([]);
    }
  };

  useEffect(() => {
    if (
      listingsSearchPayload &&
      !initialisedFromRedux &&
      (listingsSearchPayload?.type || []).length > 0
    ) {
      setinitialisedFromRedux(true);
      setType(listingsSearchPayload?.type);
    }
    if (
      listingsSearchPayload &&
      (listingsSearchPayload?.type || []).length == 0
    ) {
      setType([]);
    }
  }, [listingsSearchPayload]);

  const contentComponent = (
    <div className={classes.containerDesktop}>
      <div>
        <div className={classes.componentTitle_select}>
          <span className={classes.title_type}>{t("Type")}</span>
          <div className={classes.selectAllBtnWrapper}>
            <label className={classes.selectAllBtn}>
              <span
                className={`${classes.checkbox} ${type.includes("Select_All")
                    ? classes.checkboxSlctAllActive
                    : classes.checkboxSlctAllInactive
                  } `}
              >
                <CheckMark />
              </span>
              <input
                className={`${classes.checkboxInput} ${classes.hideCheckbox}`}
                type="checkbox"
                checked={type.includes("Select_All")}
                onChange={(e) => {
                  handleChangeSelectAll(e.target.checked);
                }}
              />
              {type.includes("Select_All")
                ? t("Tout désélectionner")
                : t("Tout sélectionner")}
            </label>
          </div>
        </div>

        {BienTypesOptions.map((bienType) => (
          <div className={classes.listItemWrapper} key={bienType.value}>
            <label className={classes.listItem}>
              <span
                className={`${classes.checkbox} ${type.includes(bienType.value)
                    ? classes.checkboxSlctActive
                    : classes.checkboxSlctInactive
                  }`}
              >
                <CheckMark />
              </span>
              <input
                className={`${classes.checkboxInput} ${classes.hideCheckbox}`}
                type="checkbox"
                checked={type.includes(bienType.value)}
                onChange={(e) => {
                  onTypeSelectChange(e.target.checked, bienType.value);
                }}
              />
              {t(bienType.value)}
            </label>
          </div>
        ))}
      </div>
      <div className={classes.validBtnWrapper}>
        <button
          className={classes.validBtn}
          onClick={() => {
            onTypesSelected(
              type
                .filter((t) => t !== "Select_All")
                .map((item) => {
                  return item
                    .replace("Appartements", "Appartement")
                    .replace("Villas", "Villa")
                    .replace("Lots de terrains", "Terrain");
                }) as TypesList
            );
            setDisplayInputTypes(false);
            setDropdownToggle(false);
          }}
        >
          {t("Valider")}
        </button>
      </div>
    </div>
  );
  const valueComponent = (
    <span className={classes.label}>
      {type.length
        ? type
          .map((item) => {
            if (item != "Select_All") {
              return t(item);
            }
          })
          .join(" ")
        : t("Type")}
    </span>
  );

  return variant === "VIEW" ? (
    <div className={classes.container}>
      {!hideTitle ? (
        <span
          style={{
            paddingLeft: "20px",
            fontWeight: 600,
          }}
        >
          {t("Type")}
        </span>
      ) : (
        <></>
      )}

      {/* <Grid
        container
        spacing={0}
        style={{
          paddingLeft: 20,
          paddingRight: 20,
          paddingTop: 12,
        }}
      > */}
      <div style={!styleForFilters ? { padding: "12px 20px 0 20px" } : {}}>
        {/* <Grid
          item
          xs={12}
          sx={{
            color: "rgb(13, 69, 153)",
            borderBottom: "solid 1px gray",
            marginBottom: "12px",
            fontWeight: 600,
          }}
        > */}
        <div className={classes.selectAllBtnWrapper}>
          <label
            className={classes.selectAllBtn}
            style={
              styleForFilters ? { fontWeight: "500", fontSize: "16px" } : {}
            }
          >
            <input
              className={`${classes.checkboxInput} ${classes.hideCheckbox}`}
              type="checkbox"
              checked={type.includes("Select_All")}
              onChange={(e) => {
                handleChangeSelectAll(e.target.checked);
              }}
            />
            <span
              className={`${classes.checkbox} ${type.includes("Select_All")
                  ? classes.checkboxSlctAllActive
                  : classes.checkboxSlctAllInactive
                } `}
            >
              <CheckMark />
            </span>
            {type.includes("Select_All")
              ? t("Tout désélectionner")
              : t("Tout sélectionner")}
          </label>
          {/* </Grid> */}
        </div>

        {BienTypesOptions.map((bienType) => (
          <div
            className={classes.listItemWrapper}
            key={bienType.value}
            style={styleForFilters ? { paddingLeft: "0px" } : {}}
          >
            <label className={classes.listItem}>
              <input
                className={`${classes.checkboxInput} ${classes.hideCheckbox}`}
                type="checkbox"
                checked={type.includes(bienType.value)}
                onChange={(e) => {
                  onTypeSelectChange(e.target.checked, bienType.value);
                }}
              />
              <span
                className={`${classes.checkbox} ${type.includes(bienType.value)
                    ? classes.checkboxSlctActive
                    : classes.checkboxSlctInactive
                  }`}
              >
                <CheckMark />
              </span>
              {t(bienType.value)}
            </label>
          </div>
        ))}
      </div>
      {/* </Grid> */}
    </div>
  ) : (
    <div>
      <Dropdown
        liststyling={classes.liststyling}
        className={`${classes.buttonWrapper} ${type.length ? classes.btnWrapperActive : ""
          } ${fromLp ? classes.buttonWrapperLp : ""}`}
        setDropdownToggle={setDropdownToggle}
        dropdownToggle={dropdownToggle}
        toggleBtnStyle={classes.toggleBtnStyle}
        onToggleActive={classes.toggleBtnActive}
        valueComponent={valueComponent}
        contentComponent={contentComponent}
        t={t}
        fromLp={fromLp}
      />
    </div>
  );
}
